<script>
  import DeleteCart from "./DeleteCart.svelte";

  import { fade } from "svelte/transition";
  import Img from "../components/Img.svelte";
  import Load from "../components/Load.svelte";
  import NoteCart from "../components/NoteCart.svelte";

  import Alert from "../components/Alert.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";
  import Quantity from "../components/Quantity.svelte";
  import format from "number-format.js";
  import { redirect } from "../pager";

  //liblary
  import axios from "axios";
  import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = [];
  let hargaTotal = 0;
  $: hargaTotal = hargaTotal;
  let itemTotal = 0;
  $: itemTotal = itemTotal;
  let items = [];
  let itemsDisplay = false;
  let notfound = false;

  function loadCart() {
    axios
      .get(settings.url + "/sipade/cart", {
        params: {
          authorization: settings.token,
        },
      })
      .then(function (response) {
        items = response.data;

        if (response.data.data !== null) {
          setTimeout(() => {
            itemsDisplay = true;

            items.data.forEach((i) => {
              i.products.forEach((a) => {
                if (a.checked == 1) {
                  hargaTotal =
                    parseInt(hargaTotal) +
                    parseInt(a.quantity) * parseInt(a.details.price);
                }
              });
            });
          }, 1000);
        } else {
          notfound = true;
        }
      })
      .catch(function (error) {
        if (error.response.status == 401) {
          localStorage.removeItem("t");
          redirect("/login");
        } else {
          notfound = true;
          if (error.response.data.message) {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: error.response.data.message,
                color: "orange",
              },
            ];
          } else {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: "Anda belum terhubung dengan baik",
                color: "orange",
              },
            ];
          }
        }
      })
      .then(function () {
        // always executed
      });
  }

  $: if (settings.loggedin == true) {
    loadCart();
  }
  let uid = Math.random().toString(36).substring(2);
  function changeSelection(id, all = false) {
    axios
      .post(settings.url + "/sipade/cart?authorization=" + settings.token, {
        productID: id,
        all: all,
        checked: true,
      })
      .then(function (response) {
        setTimeout(() => {
          countTotal();
        }, 1000);
      })
      .catch(function (error) {
        if (error.response.status == 401) {
          localStorage.removeItem("t");
          redirect("/login");
        }
      });
  }
  function countTotal() {
    hargaTotal = 0;
    itemTotal = 0;
    Array.from(document.getElementsByClassName("countTotal")).forEach((el) => {
      // Do stuff here
      if (el.checked == true) {
        hargaTotal =
          parseInt(hargaTotal) +
          parseInt(el.value.replace(/[^\d+(\d+)]+/g, ""));
        itemTotal =
          parseInt(itemTotal) +
          parseInt(
            el.getAttribute("data-quantity").replace(/[^\d+(\d+)]+/g, "")
          );
      }
    });
  }
  function autoshopChecked(id) {
    let _checkall = document.getElementById("checkall-" + id);
    let arr = Array.from(document.getElementsByClassName("items-" + id));
    let arrchecked = Array.from(
      document.querySelectorAll(".items-" + id + ":checked")
    );

    if (arr.length == arrchecked.length) {
      _checkall.checked = true;
    } else {
      _checkall.checked = false;
    }
  }

  function checkAllShopItems(id) {
    let arr = Array.from(document.getElementsByClassName("items-" + id));
    let arrchecked = Array.from(
      document.querySelectorAll(".items-" + id + ":checked")
    );

    arr.forEach((el) => {
      if (arr.length == arrchecked.length) {
        el.checked = false;
        changeSelection(el.getAttribute("data-id"), 0);
      } else {
        el.checked = true;
        changeSelection(el.getAttribute("data-id"), 1);
      }
    });
  }

  let require = {
    latlng_pembeli: undefined,
    latlng_penjual: undefined,
    pesanan: undefined,
    ongkir: undefined,
    harga: undefined,
  };
</script>

<svelte:head>
  <title>Keranjang Belanja - Dekatan</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 mb-10 right-0 z-30 px-2 mx-auto lg:w-auto w-full">
    {#each alert as a}
      <Alert color={a.color} message={a.message} />
    {/each}
  </div>
{/if}
<Navigationbar
  backbtn="true"
  title="Keranjang Belanja"
  message={navigation["message"]}
/>
<main transition:fade class="container pt-24 mx-auto mb-20 px-2">
  {#if notfound == true}
    <div class="w-full mx-auto px-2">
      <div class="w-full bg-white rounded-lg shadow-lg p-10">
        <div class="my-6 text-center">
          <h2 class="text-3xl">Keranjang belanja masih kosong !</h2>
          <p class="text-gray-500 pb-5">
            cari dan tambah dulu produk yang kamu mau
          </p>
          <a
            href="./belanja"
            class="px-10 py-2 rounded-lg bg-blue-400 text-xl text-white"
            >Cari Produk</a
          >
        </div>
      </div>
    </div>
  {:else if itemsDisplay}
    <div class="max-w-6xl mx-auto px-3 py-5 bg-white rounded-lg shadow-lg">
      <div class="flex flex-wrap wrap-extended mx-auto">
        <div
          class="w-full lg:w-3/5 lg:border-r md:border-r border-none
            border-gray-400"
        >
          <div class="lg:px-8 lg:py-2 p-2 pt-2">
            <div
              class="font-bold border-b-2 py-2 flex justify-between items-center"
            >
              <h2>Keranjang Belanja</h2>
            </div>
          </div>
          {#if items.data}
            {#each items.data as c}
              <div
                class="lg:flex flex-col lg:px-8 px-2 pb-5 border-b-4
                  border-gray-300"
              >
                <div class="my-5 mb-2 flex">
                  {#if c.summary.checkedall}
                    <input
                      type="checkbox"
                      class="form-checkbox h-5 w-5 border-2
                      border-gray-500 my-2 mr-2"
                      id="checkall-{c.shop.domain}"
                      on:change={() => checkAllShopItems(c.shop.domain)}
                      checked
                    />
                  {:else}
                    <input
                      type="checkbox"
                      class="form-checkbox h-5 w-5 border-2
                    border-gray-500 my-2 mr-2"
                      id="checkall-{c.shop.domain}"
                      on:change={() => checkAllShopItems(c.shop.domain)}
                    />
                  {/if}
                  <a
                    href="belanja/{c.shop.domain}"
                    class="text-lg font-bold block"
                    ><h2>{c.shop.nameShop}</h2>
                    <span class="text-xs font-normal text-gray-500"
                      >{c.shop.location}</span
                    >
                  </a>
                </div>

                {#each c.products as d}
                  <div class="md:table w-full leading-none mb-2">
                    <div
                      class="my-2 lg:flex md:flex block justify-between relative
                        rounded-lg"
                    >
                      <div
                        class="absolute lg:w-32 md:w-32 h-full md:h-auto
                          md:relative align-top rounded rounded-r-none flex"
                      >
                        {#if d.checked == 0}
                          <input
                            on:change={countTotal}
                            on:change={() => changeSelection(d.details.ID)}
                            on:change={() => autoshopChecked(c.shop.domain)}
                            data-quantity={d.quantity}
                            data-id={d.details.ID}
                            type="checkbox"
                            id="sumInput-{d.ID}"
                            class="countTotal form-checkbox h-5 w-5 border-2
                            border-gray-500 my-4 mr-2 items-{c.shop.domain}"
                            value={d.details.price * d.quantity}
                          />
                        {:else}
                          <input
                            on:change={countTotal}
                            on:change={() => changeSelection(d.details.ID)}
                            on:change={() => autoshopChecked(c.shop.domain)}
                            data-quantity={d.quantity}
                            data-id={d.details.ID}
                            type="checkbox"
                            id="sumInput-{d.ID}"
                            class="countTotal form-checkbox h-5 w-5 border-2
                          border-gray-500 my-4 mr-2 items-{c.shop.domain}"
                            value={d.details.price * d.quantity}
                            checked
                          />
                        {/if}
                        <picture class="relative p-1">
                          <Img
                            csscont="none"
                            showplaceholder="false"
                            id={d.details.name}
                            css="lg:w-full w-16 rounded-lg"
                            datasrc="https://pics.dekatan.com/{d.pictures
                              .fileName}"
                            alt={d.details.name}
                          />
                        </picture>
                      </div>
                      <div
                        class="pl-20 ml-6 lg:p-3 p-2 pb-0 md:p-0 md:ml-0 w-full
                          align-top"
                      >
                        <div
                          class="relative flex flex-col h-full lg:pt-0 pt-2 pr-2"
                        >
                          <a
                            href="product/{d.details.alias}-{d.details.ID}"
                            class="text-sm md:text-base font-bold"
                          >
                            {d.details.name}
                          </a>
                          <div class="mt-2 font-bold">
                            <span class="text-orange-500 mr-2">
                              {format("Rp #.###,", d.details.price)},-
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        class="lg:p-2 md:pt-3 p-2 bg-white lg:w-40 md:w-40
                          w-full rounded-r-lg"
                      >
                        <div class="flex flex-col px-2">
                          <div
                            class="flex align-center justify-center px-2
                              bg-white rounded-lg py-1"
                          >
                            <Quantity
                              {settings}
                              jumlahorder={d.quantity}
                              id={d.productID}
                              on:message={(event) =>
                                (document.getElementById(
                                  "sum-" + d.ID
                                ).innerHTML = format(
                                  "Rp #.###,",
                                  parseInt(d.details.price) *
                                    parseInt(event.detail.text)
                                ))}
                              on:message={(event) =>
                                (document.getElementById(
                                  "sumInput-" + d.ID
                                ).value =
                                  parseInt(d.details.price) *
                                  parseInt(event.detail.text))}
                              on:message={(event) =>
                                document
                                  .getElementById("sumInput-" + d.ID)
                                  .setAttribute(
                                    "data-quantity",
                                    event.detail.text
                                  )}
                              on:message={countTotal}
                            />
                          </div>
                          <DeleteCart
                            id={d.productID}
                            on:message={() => window.location.reload()}
                          />
                        </div>
                      </div>
                    </div>

                    <NoteCart note={d.note} id={d.productID} />
                    <div class="separator my-2" id="sum-{d.ID}">
                      {format("Rp #.###,", d.details.price * d.quantity)}
                    </div>
                  </div>
                {/each}
              </div>
            {/each}
          {/if}
        </div>
        <div class="w-full lg:w-2/5 h-auto p-3 pb-8 md:p-10">
          <div class="lg:sticky" style="top: 100px;">
            <div
              class="border border-gray-400 mt-3 basket-aside rounded-lg
                rounded-b-lg shadow"
            >
              <footer
                class="p-3 border-t rounded-lg bg-blue-100 border-2
                  border-gray-400 transform transition-all duration-300
                  scale-105 hover:scale-110"
              >
                <div class="flex justify-between text-base">
                  <span class="table-cell font-bold w-32">Harga total</span>
                  <span class="table-cell font-medium font-mono" id="hargaTotal"
                    >{format("Rp #.###,", hargaTotal)}</span
                  >
                </div>
                <div
                  class="flex justify-between text-gray-600 text-sm font-light"
                >
                  <span class="table-cell"
                    >*Ongkos Kirim dihitung saat Checkout</span
                  >
                </div>
              </footer>
              <div class="p-3 justify-between flex">
                {#if hargaTotal}
                  <a
                    class="text-center rounded-lg w-full mb-2 p-3 mx-1
                      bg-green-500 text-white font-bold transform transition-all
                      duration-300 scale-100 hover:scale-95 focus:outline-none"
                    href="/belanja/p/checkout"
                  >
                    Beli
                    {#if itemTotal}({format("#.###,", itemTotal)}){/if}
                  </a>
                {:else}
                  <a
                    class="text-center rounded-lg w-full mb-2 p-3 mx-1
                      bg-green-300 text-white font-bold cursor-not-allowed"
                    data-turbolinks="false"
                    href="/p/checkout"
                    on:click|preventDefault
                  >
                    Beli
                    {#if itemTotal}({format("#.###,", itemTotal)}){/if}
                  </a>
                {/if}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  {:else}
    <Load />
  {/if}
</main>
